import { BehaviourDataActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    patientRecordIntervalList: null,
    save_patientRecordInterval: null,
    isStart: false,
    isSave: false,
    secondsElapsed: 0,
    observationIntervalSecondsElapsed: 0,
    observationIntervalSecondsElapsedCustom : 0,
    reverseCounter: 0,
    incrementerForReverse: [],
    intervalCount: 1,
    recordIntervalCustomTime: null,
    incrementer: [],
    newIncrementer: [],
    observationIntervalIncrementerOne: [],
    observationIntervalIncrementerTwo: [],
    customSelectedInterval: [],
    beepFlag:false,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        /* Record Rate */
        case BehaviourDataActionTypes.get_patientRecordIntervalData.REQUEST:
            return {
                ...state,
                loading: true,
                patientRecordIntervalList: null
            }
        case BehaviourDataActionTypes.get_patientRecordIntervalData.SUCCESS:
            return {
                ...state,
                loading: false,
                patientRecordIntervalList: payload
            }
        case BehaviourDataActionTypes.get_patientRecordIntervalCustomTimeData.REQUEST:
            return {
                ...state,
                loading: true,
                recordIntervalCustomTime: null
            }
        case BehaviourDataActionTypes.get_patientRecordIntervalCustomTimeData.SUCCESS:
            return {
                ...state,
                loading: false,
                recordIntervalCustomTime: payload
            }
        case BehaviourDataActionTypes.set_intervalCount.SUCCESS:
            return {
                ...state,
                loading: false,
                intervalCount: payload,
            };
        case BehaviourDataActionTypes.reset_IntervalCount.SUCCESS:
            return {
                ...state,
                loading: false,
                intervalCount: 1,
            };
        case BehaviourDataActionTypes.start_recordIntervalTimer.SUCCESS:
            return {
                ...state,
                loading: false,
                isStart: payload
            }
        case BehaviourDataActionTypes.start_secondsElapsedForInterval.SUCCESS:
            return {
                ...state,
                loading: false,
                secondsElapsed: payload
            }

        case BehaviourDataActionTypes.start_secondsElapsedForIntervalObservation.SUCCESS:
            return {
                ...state,
                loading: false,
                observationIntervalSecondsElapsed: payload
            }

        case BehaviourDataActionTypes.reset_secondsElapsedForIntervalObservation.SUCCESS:
            return {
                ...state,
                loading: false,
                observationIntervalSecondsElapsed: payload
            }

         case BehaviourDataActionTypes.set_secondsElapsedForIntervalObservationCustom.SUCCESS:
         
            return {
                ...state,
                loading: false,
                observationIntervalSecondsElapsed: payload,
                observationIntervalSecondsElapsedCustom: payload,
            }
    
            
        case BehaviourDataActionTypes.start_ReverseSecondsElapsedForInterval.SUCCESS:
            return {
                ...state,
                loading: false,
                reverseCounter: payload
            }
        case BehaviourDataActionTypes.reset_secondsElapsedForInterval.SUCCESS:
            return {
                ...state,
                loading: false,
                secondsElapsed: payload
            }
        case BehaviourDataActionTypes.reset_reverseSecondsElapsedForInterval.SUCCESS:
            return {
                ...state,
                loading: false,
                reverseCounter: payload
            }
        case BehaviourDataActionTypes.save_patientRecordIntervalData.REQUEST:
            return {
                ...state,
                loading: true,
                save_patientRecordInterval: null
            }
        case BehaviourDataActionTypes.save_patientRecordIntervalData.SUCCESS:
            return {
                ...state,
                loading: false,
                save_patientRecordInterval: payload
            }
        case BehaviourDataActionTypes.set_customSelectedInterval.SUCCESS:
            return {
                ...state,
                customSelectedInterval: payload
            }
        case BehaviourDataActionTypes.reset_customIntervalArray.SUCCESS:
            return {
                ...state,
                customSelectedInterval: payload
            }
        case BehaviourDataActionTypes.set_beep_flag.SUCCESS:
            console.log("set_beep_flag");
            return {
                ...state,
                beepFlag: payload
            }
            
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/reducers/recordIntervalCustomReducer.js